import { routes } from './routes';

const accessorScrollTo = (scroll, to, from, savedPosition) => {
    if (!scroll) {
        return false
    }

    if (typeof scroll === 'function') {
        return scroll(to, from, savedPosition)
    }

    return scroll;
}

const defaultScrolling = {
    top: 0,
    left: 0,
    behavior: 'smooth',
};

const scrollBehavior = (to, from, savedPosition) => {
    // savedPosition is only available for popstate navigations.
    if (savedPosition) {
        return savedPosition;
    }

    // scroll to anchor by returning the selector
    if (to.hash) {
        // query-only change under the same anchor (e.g. a modal syncing its tab): stay put
        if (to.hash === from.hash && to.path === from.path) {
            return false;
        }

        const [target] = to.hash.split(':');

        let el = null;
        try {
            el = document.querySelector(target);
        } catch {
            // invalid selector, fall through to the router's own handling
        }

        // scrollIntoView honors the target's CSS scroll-margin (e.g. tailwind scroll-mt-*),
        // which window.scrollTo-based positioning does not
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
            return false;
        }

        return {
            ...defaultScrolling,
            el: target,
            top: -10,
        }
    }

    // create a new array of matched routes but reversed
    const matched = Array.isArray(to.matched) ? to.matched.slice().reverse() : [];
    const route = matched.find((r) => 'scrollToTop' in r?.meta);

    if (route) {
        const scrollToTop = accessorScrollTo(
            route.meta.scrollToTop, to, from, savedPosition
        );

        return typeof scrollToTop === 'object' ? {
            ...defaultScrolling,
            ...scrollToTop,
        } : (scrollToTop && defaultScrolling)
    }
};

export default { routes, scrollBehavior };
